import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import { useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';

const companyLogos = [
  'almirall.png',
  'bayer.png',
  'boehringer.png',
  'catapult.png',
  'ceva.png',
  'chiesi.png',
  'gsk.png',
  'murata.png',
  'takeda.png',
  'ucb.png',
];

const carouselItems = companyLogos.map((logoName, i) => {
  return <img alt={`${logoName.split('.')[0]} company logo`} key={i} src={`/logos/${logoName}`} />;
});

const responsive = {
  0: { items: 1 },
  500: { items: 2 },
  650: { items: 3 },
  900: { items: 5 },
};

export const CompaniesCarousel = () => {
  const carouselRef = useRef<AliceCarousel>(null);

  return (
    <div className="relative px-[28px] [&_.alice-carousel_img]:block [&_.alice-carousel_img]:h-15 [&_.alice-carousel_img]:mx-auto">
      {/* @ts-ignore */}
      <AliceCarousel
        ref={carouselRef}
        responsive={responsive}
        disableDotsControls
        disableButtonsControls
        mouseTracking
        items={carouselItems}
      />

      <button className="absolute top-4 left-0" onClick={e => carouselRef.current?.slidePrev(e)}>
        <ChevronLeftIcon className="w-7 h-7" />
      </button>

      <button className="absolute top-4 right-0" onClick={e => carouselRef.current?.slideNext(e)}>
        <ChevronRightIcon className="w-7 h-7" />
      </button>
    </div>
  );
};
